import React from "react";
import { Link } from "react-router-dom";
import Seal from "@/components/Seal";
import { openCookieConsent } from "@/components/CookieConsent";

export const Footer = () => (
  <footer data-testid="public-footer" className="border-t border-[var(--wechr-border)] bg-white">
    <div className="wechr-container grid grid-cols-2 gap-8 py-12 md:grid-cols-4">
      <div className="col-span-2 md:col-span-1">
        <div className="flex items-center gap-2">
          <Seal size={28} />
          <span className="font-heading text-lg font-bold text-navy-900">WECH-RB</span>
        </div>
        <p className="mt-3 max-w-xs text-sm text-[var(--wechr-muted-text)]">
          We Create Harmony with Responsible Businesses. Document-reviewed certification for EHS, ESG, ethics, anti-corruption, supplier due diligence, and AI governance.
        </p>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-navy-900">Platform</h4>
        <ul className="mt-3 space-y-2 text-sm text-[var(--wechr-muted-text)]">
          <li><Link className="hover:text-wgreen-700" to="/about">About WECH-RB</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/certification-process">Certification Process</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/assessment-criteria">Assessment Criteria</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/pricing">Pricing</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/contact" data-testid="public-footer-contact-link">Contact</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-navy-900">Verification</h4>
        <ul className="mt-3 space-y-2 text-sm text-[var(--wechr-muted-text)]">
          <li><Link className="hover:text-wgreen-700" to="/verify" data-testid="public-footer-verify-link">Verify a Certificate</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/code-of-conduct">Code of Conduct</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/apply">Apply for Certification</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-navy-900">Legal</h4>
        <ul className="mt-3 space-y-2 text-sm text-[var(--wechr-muted-text)]">
          <li><Link className="hover:text-wgreen-700" to="/privacy">Privacy Policy</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/terms">Terms of Use</Link></li>
          <li><Link className="hover:text-wgreen-700" to="/disclaimer">Disclaimer</Link></li>
          <li>
            <button
              type="button"
              onClick={openCookieConsent}
              className="text-left transition-colors hover:text-wgreen-700"
              data-testid="footer-cookie-preferences"
            >
              Cookie Preferences
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[var(--wechr-border)]">
      <div className="wechr-container flex flex-col items-center justify-between gap-2 py-5 text-xs text-[var(--wechr-muted-text)] sm:flex-row">
        <span>© {new Date().getFullYear()} WECH-RB. All rights reserved.</span>
        <span>WECH-RB certification is document-review-based and does not constitute an on-site audit.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
